import config from "src/config";
import http, { postWithBasicHeader } from "../services/apiServices";
import { ILogin } from "src/redux/interfaces/IProfile";
import { isCivilDefenseUser } from "src/utils/helpers";

export const fetchProfileData = async () => {
  const api = isCivilDefenseUser()
    ? config.CivilDefense.getProfile
    : config.BMCCompany.getProfile;
  return await http.get(api);
};
export const updateBMCProfileApi = async (data: any) => {
  return await http.post(config.BMCCompany.updateBMC, data);
};
export const registerBMCProfileApi = async (data: any) => {
  return await postWithBasicHeader(config.BMCCompany.registerBMC, data);
};

export const loginApi = async (data: ILogin) => {
  return await postWithBasicHeader(config.users.signInUser, data);
};

export const forgetPasswordApi = async (data: string) => {
  return await postWithBasicHeader(config.users.forgetPassword, {
    Email: data,
  });
};
export const restPasswordApi = async (restPasswordData: any) => {
  const api = isCivilDefenseUser()
    ? config.CivilDefense.resetPassword
    : config.users.restPassword;
  return await http.post(api, restPasswordData);
};
export const generateOTPTokenAPI = async (GenerateOTPFor: any) => {
  const res = await postWithBasicHeader(
    config.BMCCompany.generateOTPToken,
    GenerateOTPFor
  );
  return res;
};
export const validateOTPTokenAPI = async (OTPData: any) => {
  const res = await postWithBasicHeader(
    config.BMCCompany.validateOTPToken,
    OTPData
  );

  return res;
};
export const validateCompanyNameUniqueApi = async (data: any) => {
  const res = await postWithBasicHeader(
    config.BMCCompany.isCompanyNameUnique +
      `?CompanyName=${data.CompanyName}&Id=${data.Id}`,
    null
  );

  return res;
};

export const validateEmailUniqueApi = async (data: any) => {
  return await postWithBasicHeader(
    config.BMCCompany.isEmailUnique +
      `?Email=${encodeURI(data.EmailAddress)}&Id=${data.Id}`,
    null
  );
};

export const validatePhoneNumberUniqueApi = async (data: any) => {
  return await postWithBasicHeader(
    config.BMCCompany.isPhoneNumberUnique +
      `?PhoneNumber=${encodeURIComponent(data.PhoneNumber)}&Id=${data.Id}`,
    null
  );
};
export const sendRequestToOwnerApi = async (payload: any) => {
  return http.post(config.BMCCompany.sendRequestToOwner, payload);
};